import React from 'react';
import { Box, Typography, Button, SelectChangeEvent } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';

interface AddDevicesModalProps {
    deviceTypeOptions: { id: string; label: string }[];
    deviceType: string;
    setDeviceType: (val: string) => void;
    selectedFile: File | null;
    handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddDevicesModal: React.FC<AddDevicesModalProps> = ({
    deviceTypeOptions,
    deviceType,
    setDeviceType,
    selectedFile,
    handleFileChange
}) => {
    const handleDownloadFormat = () => {
        const link = document.createElement('a');
        link.href = '/device_bulk_upload.csv'; 
        link.download = 'device_upload_format.csv'; 
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, mt: 2, pb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography sx={{ fontWeight: 'bold' }}>Device type</Typography>
                <Box>
                    <Dropdown 
                        options={deviceTypeOptions}
                        selectedValue={deviceType}
                        handleChange={(event: SelectChangeEvent<string>) => setDeviceType(event.target.value)}
                        placeholder="Select Type"
                        height="40px"
                        width="190px"
                        displayEmpty
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                <Button variant="outlined" component="label" sx={{ textTransform: 'none', height: '40px' }}>
                    Choose File
                    <input type="file" hidden accept=".csv, .xlsx, .xls" onChange={handleFileChange} />
                </Button>
                <Typography variant="body2" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '160px' }}>
                    {selectedFile ? selectedFile.name : 'No file chosen'}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button variant="outlined" onClick={handleDownloadFormat} color="inherit" sx={{ height: '40px', minWidth: '120px', borderRadius: '4px' }}>
                    Format
                </Button>
            </Box>
        </Box>
    );
};

export default AddDevicesModal;